module.exports = __webpack_public_path__ + "assets/4fd19141210f66a78d72c2529a00ff17.svg";